<template>
    <div>
        <!-- STATE SELECT -->
<!--        <b-btn @click="log">LOG</b-btn>-->
        <div class="mb-3">
            State:
            <multiselect id="state"
                         v-model="selectedState"
                         :options="states"
                         label="fullState"
                         name="state"
                         track-by="state"
                         select-label=""
                         deselect-label=""
                         placeholder="State"
                         :searchable="true"
                         :multiple="false"
                         class="mb-2"
                         @input="getProducts"
                         :preselect-first="true"
            >
            </multiselect>
        </div>

        <div v-if="products.length && !isLoading && !saving" class="mb-3" >
            <small>Page Preview</small><br/>
            <b-btn-group size="sm"  >
                <b-btn variant="primary" @click="showSideBar('Social Studies')">SS</b-btn>
                <b-btn variant="primary"  @click="showSideBar('Adopted Social Studies')" >Adopted SS</b-btn>
                <b-btn variant="success"  @click="showSideBar('Science')" >SN</b-btn>
                <b-btn variant="success"  @click="showSideBar('Explore Science')" >EXSN</b-btn>
                <b-btn variant="warning"  @click="showSideBar('Health & Wellness')" >HW</b-btn>
                <b-btn variant="danger"  @click="showSideBar('PreK')" >PreK</b-btn>
                <b-btn variant="info"  @click="showSideBar('Summer')" >Summer</b-btn>
            </b-btn-group>
        </div>

        <!-- SEARCH FILTER -->
        <div class="mb-3" v-if="products.length && !isLoading && !saving">
            <b-input-group>
                <template #prepend>
                    <b-btn variant="dark" @click="searchProducts">
                        <font-awesome-icon :icon="['fas', 'search']" />
                    </b-btn>
                </template>
                <b-input v-model="searchInput" @input="searchProducts" placeholder="Search"></b-input>
            </b-input-group>

            <b-row class="my-3">
                <b-col>
                    Grades:<br/>
                    <b-btn-group>
                        <b-btn v-for="(i) in 10" :pressed.sync="gradeFilter[i-2]" :variant="gradeFilter[i-2] ? 'primary':  'light'"
                               @click="searchProducts"
                               class="border-dark">
                            {{i-2}}
                        </b-btn>
                    </b-btn-group>
                </b-col>
                <b-col>
                    <br/>
                    <multiselect id="topic"
                                 v-model="topicFilters"
                                 :options="topics"
                                 label="name"
                                 name="topic"
                                 track-by="id"
                                 select-label=""
                                 deselect-label=""
                                 placeholder="Topics"
                                 :searchable="true"
                                 :multiple="true"
                                 class="mb-2"
                                 @input="searchProducts"
                    >
                    </multiselect>
                </b-col>
                <b-col>
                    <br/>
                    <multiselect id="languages"
                         v-model="langFilters"
                         :options="languages"
                         label="name"
                         track-by="id"
                         select-label=""
                         deselect-label=""
                         name="language"
                         placeholder="Languages"
                         :searchable="true"
                         :multiple="true"
                         @input="searchProducts"
                    >
                    </multiselect>
                </b-col>

            </b-row>

            <b-row>
                <b-col>
                    <b-checkbox v-model="showPhysicalSku">Physical Skus</b-checkbox>
                    <b-checkbox v-model="highlightConflicts">Highlight Conflicts</b-checkbox>
                    <b-checkbox v-model="onlyShowConflicts" @input="searchProducts">Show Only Potential Conflicts</b-checkbox>
                    <div v-if="onlyShowConflicts">
    <!--                    <div v-for="(conflict, key) in conflicts">-->
    <!--                        <strong>{{key}}</strong>: <span class="ml-2">{{conflict.join(', &nbsp;')}}</span>-->
    <!--                    </div>-->
                    </div>
                </b-col>
                <b-col>
                    <b-btn variant="primary" @click="save" :disabled="!selectedState || saving || isLoading" size="md" class="float-right m-3">Save</b-btn>
                </b-col>
            </b-row>
        </div>

        <!-- PRODUCT MATRIX -->
        <div v-if="schoolYear">
            <b-table :fields="tableFields" :items="filteredProducts" :busy="isLoading || saving" ref="productTable" v-if="filteredProducts" striped>
                <template #table-busy>
                    Loading...
                </template>
                <template #cell(sku)="data">
                    <template v-if="!showPhysicalSku">{{data.item.sku}}</template>
                    <template v-else>{{physicalProductMap[data.item.legacy_id].sku}}</template>

                </template>

<!--                <template #cell(language)="data">-->
<!--                    <template v-if="data.item.language == 'en'">English</template>-->
<!--                    <template v-else-if="data.item.language == 'es'">Spanish</template>-->
<!--                </template> -->
                <template #cell(topic)="data">
                    <template v-if="data.item.topic == 'Social Studies'">SS</template>
                    <template v-else-if="data.item.topic == 'Science'">SN</template>
                    <template v-else-if="data.item.topic == 'Health Wellness'">HW</template>
                    <template v-else>{{ data.item.topic }}</template>

                </template>
                <template #cell(prevYear)="data">
<!--                    {{data.item.years}}-->
                    <b-checkbox :checked="data.item.years[schoolYear-1]" disabled/>
                </template>
                <template #cell(year1)="data">
                    <b-checkbox v-model="data.item.years[schoolYear]" @input="setYear($event, data.item, schoolYear)"/>
                </template>
                <template #cell(year2)="data">
                    <b-checkbox v-model="data.item.years[schoolYear+1]" @input="setYear($event, data.item, schoolYear+1)"/>
                </template>
                <template #cell(actions)>
<!--                    <b-btn variant="danger">-->
<!--                        <font-awesome-icon :icon="['fas', 'trash']" />-->
<!--                    </b-btn>-->
                </template>
            </b-table>

        </div>


        <!-- Sidebar Page Display -->
        <template>
            <b-sidebar id="sidebar" ref="sidebar" v-model="sidebar.visible" :backdrop="false" bg-variant="secondary" :shadow="'lg'" width="400px">
                <b-row class="mt-4 p-1 bg-light">
                    <b-col cols="9">
                        <h3 class="">{{ sidebar.header }}
                            <b-btn size="sm" @click="updateSidebarProducts" variant="success">
                                <font-awesome-icon :icon="['fas', 'sync']" />
                            </b-btn>
                        </h3>

                    </b-col>
                    <b-col cols="3">
                        <b-checkbox size="sm" switch :value="schoolYear+1" :unchecked-value="schoolYear" @input="updateSidebarYear($event)"></b-checkbox> {{sidebar.year}}
                    </b-col>
                </b-row>
                <b-table :items="sidebar.pubs" :fields="pageFields" striped ref="sidebarTable" class="bg-light">
                </b-table>
            </b-sidebar>
        </template>
        <!-- modal -->
        <b-modal id="physicalProductModal">
            <b-input placeholder="Search" v-model="physicalSearch" @input="searchPhysical"></b-input>
            <b-container>
                <b-row>
                    <b-col style="text-decoration: underline; font-weight: bold">SKU</b-col>
                    <b-col style="text-decoration: underline; font-weight: bold">ID</b-col>
                </b-row>
                <b-row v-for="(product, i) in searchedProducts" class="my-2">
                    <b-col>{{product.sku}}</b-col>
                    <b-col>{{product.ID}}</b-col>
                    <hr/>
                </b-row>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
import {publicationStates} from "@/common/states";
import {mapGetters, mapState} from "vuex";
import {
    getAdoptedSocialStudiesPublications, getExploreSciencePublications,
    getHealthWellnessPublications, getNewSocialStudiesPublications,
    getPreKPublications, getSciencePublications, getSummerPublications, getUniquePageProducts
} from "@/common/publicationFilters";

export default {
    name: "StateYearMapping",
    computed: {
        displayPrevYear() { return `${this.schoolYear-1}-${this.schoolYear}`},
        displayYear() { return `${this.schoolYear-1}-${this.schoolYear}`},
        displayNextYear() { return `${this.schoolYear}-${this.schoolYear+1}`},
        ...mapState({
            storeSelectedState: (state) => state.stateData.selectedState,
        }),
        ...mapGetters({
            schoolYear: 'getActiveSchoolYear',
            socialStudiesPubs: 'getNewSocialStudiesPublications',
            adoptedSSPubs: 'getAdoptedSocialStudiesPublications',
            sciencePubs: 'getSciencePublications',
            exSciencePubs: 'getExploreSciencePublications',
            HWPubs: 'getHealthWellnessPublications',
            preKPubs: 'getPreKPublications',
            summerPubs: 'getSummerPublications',
        })
    },
    data: () => ({
        showPhysicalSku: false,
        isLoading: false,
        states: publicationStates,
        selectedState: null,
        save: null,
        saving: false,
        highlightConflicts: false,
        onlyShowConflicts: false,
        conflicts: {},
        conflictsBySku: {},
        skuYears: {},

        sidebar: {
            header: "",
            pubs: [],
            year: 2025,
            visible: false,
        },

        // Filters
        topicFilters: [],
        topics: [
            {id: "SS", name: 'Social Studies'},
            {id: "SN", name: 'Science'},
            {id: "HW", name: 'Health Wellness'},
            {id: "Other", name: 'Other'},

        ],
        langFilters: [],
        languages: [
            {id: "en", name: 'English'},
            {id: "es", name: 'Spanish'},
        ],
        gradeFilter: {
            [-1]: false,
            0: false,
            1: false,
            2: false,
            3: false,
            4: false,
            5: false,
            6: false,
            7: false,
            8: false
        },


        // State Products
        searchInput: "",
        products: [],
        stateProducts: [],
        stateYearProducts: [],
        productYears: {},
        filteredProducts: [],

        // Physical Products
        physicalSearch: "",
        physicalProducts: [],
        physicalProductMap: {},
        searchedProducts: [],

        // Table Fields
        tableData: [],
        newProduct: {},
        tableFields: [],
        pageFields: [
            {key: 'sku', label: 'SKU',},
            {key: 'grade', label: 'Grade'},
            {key: 'language', label: 'Language'},
        ]
    }),
    async created() {
        console.log(this.storeSelectedState)
        // this.selectedState = this.storeSelectedState;
        // this.getProducts();
        this.getPhysicals();
        this.save = _.debounce(this.saveData, 1000);


        var response = await this.axios.get('schoolyear');
        this.schoolYear = response.data;
        this.sidebar.year = this.schoolYear;

        this.tableFields = [
            // {key:'legacy_id', label:'Legacy ID', sortable:true},
            {key:'sku', label:'Sku', sortable:true},
            {key:'grade', label:'Grade', sortable:true},
            {key:'topic', label:'Topic', sortable:true},
            {key:'language', label:'Lang', sortable:true},
            // {key:'prevYear', label: `Previous Year (${this.displayPrevYear})`, sortable:true},
            {key:'year1', label: `Current Year (${this.displayYear})`, sortable:true},
            {key:'year2', label: `Next Year (${this.displayNextYear})`, sortable:true},
            // 'actions'
        ];


        // console.log("Current Year: ", this.current_year);
        // console.log("Current Month: ", this.current_month);
        // console.log("School Year: ", this.schoolYear);
    },
    mounted() {
    },
    watch: {
        highlightConflicts() {
            this.searchProducts();
            this.$refs.productTable.refresh();
        },
    },
    methods: {
        updateSidebarProducts() {
            this.$store.commit('setPublications',  this.products.filter(x => x.years[this.sidebar.year] == 1));

            this.showSideBar(this.sidebar.header);
            this.$nextTick(() => {
                this.$refs.sidebarTable.refresh();
            })

        },
        updateSidebarYear(year) {
            this.sidebar.year = year;
            this.updateSidebarProducts();
        },
        showSideBar(headerTxt) {
            this.sidebar.header = headerTxt;
            switch (headerTxt) {
                case 'Social Studies':
                    this.sidebar.pubs = getNewSocialStudiesPublications(this.stateProducts, 'en');
                    break;
                case 'Adopted Social Studies':
                    this.sidebar.pubs = getAdoptedSocialStudiesPublications(this.stateProducts, 'en');
                    break;
                case 'Science':
                    this.sidebar.pubs = getSciencePublications(this.stateProducts, 'en');
                    break;
                case 'Explore Science':
                    this.sidebar.pubs = getExploreSciencePublications(this.stateProducts, 'en');
                    break;
                case 'Health & Wellness':
                    this.sidebar.pubs = getHealthWellnessPublications(this.stateProducts, 'en');
                    break;
                case 'PreK':
                    this.sidebar.pubs = getPreKPublications(this.stateProducts, 'en');
                    break;
                case 'Summer':
                    this.sidebar.pubs = getSummerPublications(this.stateProducts, 'en');
                    break;
            }
            this.sidebar.visible = true;
        },
        setYear(value, data, year) {
            console.log('Setting Year', data.sku, year, value);
            let product = this.products.find(a => a.legacy_id == data.legacy_id)
            product.years[year] = value;

            if (this.sidebar.visible)
                this.updateSidebarProducts()

            this.$nextTick(() => {
                this.$forceUpdate();
                this.$refs.sidebarTable.refresh();
                this.$refs.productTable.refresh();
            });
        },
        conflictKey(product) {
            return `${product.topic}_${product.grade}_${product.language}`;
        },
        selectAll(year) {
            console.log("Selecting All", year);
            for (let i = 0; i < this.products.length; ++i) {
                console.log(`Setting ${year} for ${this.stateProducts[i].sku}`);
                this.products[i].years[year] = true;
            }
            this.searchProducts();
            this.$nextTick(() => {
                this.$forceUpdate();
                this.$refs.productTable.refresh();
            });
        },
        async getProducts() {
            this.isLoading = true;
            let response = await this.axios.get(`/product/publications/${this.selectedState.state}`)
            this.stateProducts = response.data;


            let response2 = await this.axios.get('/product/years', {params: {state: this.selectedState.state}})
            this.stateYearProducts = response2.data;

            // Merge Years data & State Products
            this.products = [];
            for (let i = 0; i < this.stateProducts.length; ++i) {
                let stateProduct = this.stateProducts[i];
                let productYears = this.stateYearProducts.filter((a) => a.legacy_id == stateProduct.legacy_id);
                if (!productYears)
                    productYears = [];

                // Get all years for
                let stateYearBlacklist = this.stateYearProducts.filter((a) => a.legacy_id == stateProduct.legacy_id);

                stateProduct['years'] = {
                    [this.schoolYear-1]: true,
                    [this.schoolYear]: true,
                    [this.schoolYear+1]: true
                };

                for (let j = 0; j < stateYearBlacklist.length; ++j) {
                    let stateYear = stateYearBlacklist[j];

                    stateProduct['years'][stateYear['year']] = false;
                }

                this.products.push(stateProduct);
            }

            // Find Conflicts
            let keys = {};
            for (let i = 0; i < this.stateProducts.length; ++i) {
                let product = this.stateProducts[i];
                let key = this.conflictKey(product);

                // Has Conflict?
                if (keys.hasOwnProperty(key) && !keys[key].includes(product.sku)) {
                    keys[key].push(product.sku);
                    this.conflicts[key] = keys[key];
                }
                else
                    keys[key] = [product.sku];
            }

            for (let key in this.conflicts) {
                for (let index in this.conflicts[key]) {
                    this.conflictsBySku[this.conflicts[key][index]] = 1;
                }
            }

            this.searchProducts();
            if (this.sidebar.visible === true)
                this.showSideBar(this.sidebar.header)

            this.isLoading = false;
        },
        getPhysicals() {
            this.axios.get('/product/physical').then((response) => {
                this.physicalProducts = response.data.products;
                this.searchedProducts = this.physicalProducts;
                this.physicalProductMap = {};
                for (let i = 0; i < this.physicalProducts.length; ++i) {
                    this.physicalProductMap[this.physicalProducts[i].ID] = this.physicalProducts[i];
                }
            })
        },
        searchProducts() {
            console.log("Searching Products");
            this.filteredProducts = this.products;

            // Set Row Variant
            this.filteredProducts.forEach((a) => {
                if (this.highlightConflicts && this.conflictsBySku[a.sku])
                    a._rowVariant = "warning";
                else
                    a._rowVariant = "";
            })


            if (this.topicFilters.length > 0) {
                this.filteredProducts = this.products.filter((a) => {
                    return this.topicFilters.length === 0 || this.topicFilters.findIndex(b => b.name === a.topic) !== -1
                })
            }

            if (this.langFilters.length > 0) {
                this.filteredProducts = this.filteredProducts.filter((a) => {
                    return this.langFilters.length === 0 || this.langFilters.findIndex(b => b.id === a.language) !== -1
                })
            }

            let allOff = Object.values(this.gradeFilter).every((a) => !a);
            if (!allOff) {
                this.filteredProducts = this.filteredProducts.filter((a) => {
                    return this.gradeFilter[a.grade]
                });
            }


            // onlyShowConflicts
            if (this.onlyShowConflicts) {
                this.filteredProducts = this.filteredProducts.filter((a) => {
                    return this.conflictsBySku[a.sku]
                })
            }

            if (this.searchInput === "") {
                return;
            }

            let search = this.searchInput.toLowerCase();

            this.filteredProducts = this.filteredProducts.filter((a) => {
                return (a.legacy_id + '').includes(search)
                    || a.sku.toLowerCase().includes(search)
                    || a.topic.toLowerCase().includes(search)
                    || (a.year && (a.year+'').includes(search))
                    || this.physicalProductMap[a.legacy_id].sku.toLowerCase().includes(search)
            })
        },
        searchPhysical() {
            if (this.physicalSearch == "") {
                this.searchedProducts = this.physicalProducts;
            }

            this.searchedProducts = this.physicalProducts.filter((a) => {
                return (a.ID + '').includes(this.physicalSearch)
                    || a.sku.toLowerCase().includes(this.physicalSearch)
            });
        },
        saveData() {
            // console.log("Saving");
            this.saving = true;
            let rows = [];
            let remove = [];

            for (let i = 0; i < this.products.length; ++i) {
                for (let year in this.products[i].years) {

                    // Remove
                    if (this.products[i].years[year] == 1) {
                        continue;
                        // remove.push({
                        //     legacy_id: this.products[i].legacy_id,
                        //     sku: this.products[i].sku,
                        //     year: year,
                        //     state: this.selectedState,
                        // });
                        // continue;
                    }

                    // Add
                    rows.push({
                        legacy_id: this.products[i].legacy_id,
                        sku: this.products[i].sku,
                        year: year,
                        state: this.selectedState.state,
                    });
                }
            }

            // console.log('Add:', rows);
            // console.log('Remove:', remove);

            this.axios.post('/product/years', {add: rows, remove: remove, year: this.schoolYear, state: this.selectedState.state})
                .then((response) => {
                    this.$swal({
                        toast: true,
                        html: 'saved',
                        type: 'success',
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 2500
                    })
                    this.saving = false;
                })
                .catch((e) => {
                    this.$bvToast.toast("Something went wrong: " + e);
                    this.saving = false;
                });
        }
    }
}
</script>

<style scoped>

</style>